

























import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "send-email-component",
})
export default class SendEmailComponent extends Vue {
  goToCity() {
    this.$router.push("/").catch((error) => {
      // do nothing
      // do nothing
      window.location.reload();
    });
  }
  checkLocalToken() {
    return localStorage.getItem("token");
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
}
